import { ElementCategory, StandardType } from "@easy-email-pro-core/constants";
import { StandardBlockQuoteElement } from "@easy-email-pro-core/typings";
import { createBlock, mergeBlock, t } from "@easy-email-pro-core/utils";
import React from "react";
import { Text } from "@easy-email-pro-core/components/Elements";
import { BasicBlock } from "@easy-email-pro-core/components";

const defaultData: StandardBlockQuoteElement = {
  type: StandardType.STANDARD_BLOCK_QUOTE,
  data: {},
  attributes: {
    "padding-top": "3px",
    "padding-bottom": "3px",
    "padding-left": "2px",
    "padding-right": "2px",
    "font-size": "16px",
    "line-height": "120%",
    "font-weight": "normal",
    "border-width": "2px",
    "border-color": "#000000",
  },
  children: [],
};

export const StandardBlockquote = createBlock<StandardBlockQuoteElement>({
  get name() {
    return t("Blockquote");
  },
  defaultData: defaultData,
  type: StandardType.STANDARD_BLOCK_QUOTE,
  create: (payload) => {
    return mergeBlock(
      {
        type: StandardType.STANDARD_BLOCK_QUOTE,
        data: {},
        attributes: {
          "border-width": "5px",
          "border-color": "#000000",
        },
        children: [],
      },

      payload
    );
  },
  category: ElementCategory.TEXT,
  render(params) {
    const { node } = params;

    const attributes = node.attributes;

    return (
      <Text idx={params.idx} data={node.data} {...attributes}>
        <BasicBlock
          tag={"blockquote"}
          params={{
            ...params,
            node: {
              ...params.node,
              attributes: {
                style: `border-left: ${attributes["border-width"]} solid ${attributes["border-color"]};margin:0px;padding:0 1em;`,
              } as any,
            },
          }}
        />
      </Text>
    );
  },
});
